module.exports = __webpack_public_path__ + "img/hell-yeah.a079db2f.png";